import axios from './axios';

export const getSemuaBadge = () => {
  return axios.get(`/admin/badge`);
};
